import { css } from 'styled-components';
import {
  SpacingName, ThemedFunctor, grid, gridUnit,
} from '@doveit/lego';

export const items: ThemedFunctor = ({
  theme,
}) => css`
  ${grid(theme, {
    gutter: SpacingName.SMALLEST,
  })}
`;

export const item: ThemedFunctor = ({
  theme,
  $inline,
}) => css`
  ${gridUnit(theme, {
    gutter: SpacingName.SMALLEST,
    size: {
      MD: 1 / $inline,
    },
  })}
`;
